import * as $ from 'jquery';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { AutomationComponent } from './components/services/automation/automation.component';
import { BrowserModule } from '@angular/platform-browser';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { EngineeringComponent } from './components/services/engineering/engineering.component';
import { FooterComponent } from './components/footer/footer.component';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './components/home/home.component';
import { MainComponent } from './components/main/main.component';
import { mainRoutes } from './routes/main.routing';
import { NgModule } from '@angular/core';
import { PartnersComponent } from './components/partners/partners.component';
import { ProgrammingComponent } from './components/services/programming/programming.component';
import { RouterModule } from '@angular/router';
import { ServicesComponent } from './components/services/services.component';
import { ErrorsComponent } from './components/errors/errors.component';
import { ShareModule} from 'ng2share/share.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

@NgModule({
  declarations: [
    MainComponent,
    AboutUsComponent,
    ContactUsComponent,
    PartnersComponent,
    HomeComponent,
    ServicesComponent,
    ErrorsComponent,
    AutomationComponent,
    ProgrammingComponent,
    EngineeringComponent,
    FooterComponent],
  imports: [
    ShareModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    ToastModule.forRoot(),
    RouterModule.forRoot(mainRoutes, { useHash: true })
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [MainComponent]
})
export class KatisoModule { }



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/app/katiso.module.ts